export const isImage = (pathOrUrl: string, isPath?: boolean) =>
  new RegExp(`\\.(png|svg|jpg|jpeg|avif|webp)${isPath ? "$" : ""}`).test(
    pathOrUrl,
  );
export const isAudio = (pathOrUrl: string, isPath?: boolean) =>
  new RegExp(`\\.(mp3|wav|ogg)${isPath ? "$" : ""}`).test(pathOrUrl);
